import React from 'react';
import Header from '../components/Header/Header';
import FloatingIcons from '../components/FloatingIcons/FloatingIcons';
import Footer from '../components/Footer/Footer';

function Home() {
  return (
    <div className="home-page">
      <Header />
      <FloatingIcons />
      <Footer />
    </div>
  );
}

export default Home;